enum Currency {
  USD = 'USD',
  CAD = 'CAD',
  MXN = 'MXN',
  EUR = 'EUR',
  GBP = 'GBP',
}

export { Currency };
